import { useEffect, useMemo, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useLocation } from 'react-router-dom';
import Noimage from '../../assets/noimage.png';
import env from '../../config/env';
import { useAxios } from '../../utils/hook/useAxios';
import DetailsAnnonceModal from '../DetailsAnnonceModal';

function AnnonceItem2({ propsData, onAjouter }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const axios = useAxios();
  const me = window.localStorage.getItem('me');
  const user = JSON.parse(me);

  const parseSearchDate = (raw) => {
    if (!raw) return null;
    const parts = raw.split(' ');
    if (parts.length < 6) return null;
    const date = new Date(parts.slice(1, 4).join(' ') + ' ' + parts[4] + ' ' + parts[5]);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const start = searchParams.get('start');
  const end = searchParams.get('end');

  var startDate = start.split(' ');
  // Reconstruire la chaîne de date dans un format reconnu par JavaScript
  startDate = startDate.slice(1, 4).join(' ') + ' ' + startDate[4] + ' ' + startDate[5];

  var endDate = end.split(' ');
  // Reconstruire la chaîne de date dans un format reconnu par JavaScript
  endDate = endDate.slice(1, 4).join(' ') + ' ' + endDate[4] + ' ' + endDate[5];

  const dateEntree = useMemo(() => parseSearchDate(start), [start]);
  const dateSortie = useMemo(() => parseSearchDate(end), [end]);

  const [IsUnaivalable, setIsUnaivalable] = useState(false);
  // const [tampo, setTampo] = useState(0);
  // const PREAVIS = [1, 2, 3, 6, 12, 24, 48];
  //const TAMPO = [3, 4, 5, 6, 7, 8, 12, 24, 48, 36];

  const [IsInstanne, setIsInstanne] = useState(true);
  const [nombreReviews, setNombreRevviews] = useState(0);
  const [meanReviews, setMeanReviews] = useState(0);
  const [ReviewsIsloading, setReviewsIsLoading] = useState(true);

  const [isVoiturePresente, setIsVoiturePresente] = useState(() => {
    try {
      const list = JSON.parse(localStorage.getItem('selectedVoitures')) || [];
      return list.some((v) => v.id_de_la_voiture === propsData.Vehicle.id);
    } catch {
      return false;
    }
  });
  const handleAjouter = (vehicleId) => {
    // Créer un objet contenant les données à sauvegarder

    if (!dateEntree || !dateSortie) return;
    const selectedVoiture = {
      dateEntree: dateEntree,
      dateSortie: dateSortie,
      prix_par_jour: propsData.reservationPrice,
      nombre_de_jours: (dateSortie.getTime() - dateEntree.getTime()) / (1000 * 3600 * 24),
      id_de_la_voiture: vehicleId,
      image_principal: propsData?.Vehicle?.images.split(',')[0],
      driverId: propsData.Vehicle.userId,
      vehiculeAnnonceId: propsData.vehiculeAnnonceId,
    };

    // Récupérer la liste actuelle des voitures sélectionnées dans le localStorage
    const selectedVoitures = JSON.parse(localStorage.getItem('selectedVoitures')) || [];

    // Vérifier si la voiture est déjà présente dans la liste
    const existingVoitureIndex = selectedVoitures.findIndex(
      (voiture) => voiture.id_de_la_voiture === selectedVoiture.id_de_la_voiture
    );

    // Si la voiture n'est pas déjà présente, l'ajouter à la liste
    if (existingVoitureIndex === -1) {
      selectedVoitures.push(selectedVoiture);

      // Mettre à jour le localStorage avec la nouvelle liste
      localStorage.setItem('selectedVoitures', JSON.stringify(selectedVoitures));
      onAjouter();
    }
    setIsVoiturePresente(true);
  };

  const handleSupprimer = (vehicleId) => {
    // Récupérer la liste actuelle des voitures sélectionnées dans le localStorage
    let selectedVoitures = JSON.parse(localStorage.getItem('selectedVoitures')) || [];

    // Trouver l'index de la voiture à supprimer dans la liste
    const voitureIndex = selectedVoitures.findIndex(
      (voiture) => voiture.id_de_la_voiture === vehicleId
    );

    // Vérifier si la voiture à supprimer existe dans la liste
    if (voitureIndex !== -1) {
      // Supprimer l'élément de la liste
      selectedVoitures.splice(voitureIndex, 1);

      // Mettre à jour le localStorage avec la nouvelle liste
      localStorage.setItem('selectedVoitures', JSON.stringify(selectedVoitures));
    } else {
    }
    setIsVoiturePresente(false);
  };

  const calculateAverageRating = (reviews) => {
    if (!reviews.length) return '0.00';
    const totalRating = reviews.reduce((sum, review) => sum + parseFloat(review.rating), 0);
    return (totalRating / reviews.length).toFixed(2);
  };

  useEffect(() => {
    if (!dateEntree || !dateSortie) return;
    let fetchReviews = async () => {
      try {
        const response = await axios.get(
          `/unavailabilities/getbyvehiculeid/` + propsData.Vehicle.id
        );

        if (response.data.length > 0) {
          for (var i = 0; i < response.data.length; i++) {
            const startDateObj = new Date(response.data[i].start_date);
            const endDateObj = new Date(response.data[i].end_date);
            const dateInObj = dateEntree;
            const dateOutObj = dateSortie;
            // Vérifier s'il y a chevauchement

            const isOverlap =
              (startDateObj <= dateInObj && dateInObj <= endDateObj) || // Vérifier si DateIn est dans [startDate, endDate]
              (startDateObj <= dateOutObj && dateOutObj <= endDateObj) || // Vérifier si DateOut est dans [startDate, endDate]
              (dateInObj <= startDateObj && endDateObj <= dateOutObj); // Vérifier si [startDate, endDate] est entièrement inclus dans [dateIn, dateOut]

            setIsUnaivalable(isOverlap);
            if (isOverlap === true) break;
          }
        }

        const resp = await axios.get(
          `/reservationpreferences/getbyvehiculeid/` + propsData.Vehicle.id
        );

        if (resp.data.reservationsInstantanne == true) {
          setIsInstanne(true);
        } else {
          console.log('date de commenceement', resp.data.reservationsInstantanne);

          const startDate = dateEntree;
          const today = new Date();

          if (
            startDate.getDate() == today.getDate() &&
            startDate.getMonth() == today.getMonth() &&
            startDate.getFullYear() == today.getFullYear()
          ) {
            setIsInstanne(false);
          }
        }
        //setTampo(resp.data.HomePeriodTempo);

        const reviewsResp = await axios.get(`/reviews/getbyvehiculeId/` + propsData.Vehicle.id);

        setNombreRevviews(reviewsResp.data.length);
        setMeanReviews(calculateAverageRating(reviewsResp.data) || 0.0);
        console.log('reviewsResp.data.length', reviewsResp.data.length);
        console.log(
          'calculateAverageRating(reviewsResp.data)',
          calculateAverageRating(reviewsResp.data)
        );
        setReviewsIsLoading(false);
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
        setReviewsIsLoading(false);
      }
    };
    fetchReviews();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [propsData.Vehicle.id, dateEntree, dateSortie]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Récupérer le contenu de l'URL
    fetch(`${env.apiUrl}/location-voiture/${propsData.vehiculeAnnonceId}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Erreur lors du chargement du contenu.');
        }
        return response.text();
      })
      .then((data) => {
        // Mettre à jour le contenu de la modal
        setIsLoading(false);
      })
      .catch((error) => {
        console.error(error);
        // Gérer les erreurs
        setIsLoading(false);
      });
  }, [propsData.vehiculeAnnonceId]);

  return (
    <>
      <div className="vehicle-tooltip-card w-100">
        {/* IMAGE */}
        <div className="position-relative">
          {isLoading ? (
            <Skeleton height={180} />
          ) : (
            <a href={`/location-voiture/${propsData.vehiculeAnnonceId}`}>
              <img
                className="img-fluid w-100"
                src={propsData?.Vehicle?.images?.split(',')[0] || Noimage}
                alt="Annonce"
                style={{
                  height: '180px',
                  objectFit: 'cover',
                  borderRadius: '0.4rem',
                }}
                data-bs-toggle="modal"
                data-bs-target={`#fullScreen${propsData.vehiculeAnnonceId}`}
              />
            </a>
          )}

          {!isLoading && (
            <span className="badge bg-white text-secondary position-absolute top-0 end-0 m-2 shadow-sm">
              SUR RENDEZ-VOUS
            </span>
          )}
        </div>

        {/* INFOS */}
        <div className="p-2">
          {/* TITRE */}
          <h6 className="mb-1">{isLoading ? <Skeleton /> : propsData.Vehicle.description}</h6>

          {/* NOTE */}
          <div className="small text-primary">
            <i className="bi bi-star-fill me-1"></i>
            {ReviewsIsloading ? <Skeleton width={40} /> : `${meanReviews} (${nombreReviews})`}
          </div>

          {/* DISTANCE */}
          <div className="small text-muted">
            <i className="bi bi-geo-alt me-1"></i>
            {isLoading ? <Skeleton width={60} /> : `${propsData?.distance} km`}
          </div>

          {/* PRIX */}
          <div className="fw-bold fs-5 mt-1">
            {isLoading ? <Skeleton width={60} /> : `${propsData.reservationPrice} €`}
          </div>

          {/* DURÉE */}
          <div className="small text-muted">
            {isLoading ? <Skeleton width={80} /> : `Pour ${propsData?.nombreJours} jours`}
          </div>

          {/* ACTION */}
          {IsInstanne && user?.id !== propsData.Vehicle.userId && (
            <>
              {IsUnaivalable ? (
                <div className="text-danger small mt-1">Non disponible</div>
              ) : !isVoiturePresente ? (
                <button
                  className="btn btn-sm btn-primary w-100 mt-2"
                  onClick={() => handleAjouter(propsData.Vehicle.id)}
                >
                  Demande de réservation
                </button>
              ) : (
                <button
                  className="btn btn-sm btn-danger w-100 mt-2"
                  onClick={() => handleSupprimer(propsData.Vehicle.id)}
                >
                  Annuler la demande
                </button>
              )}
            </>
          )}

          {!IsInstanne && (
            <div className="text-warning small mt-2">Réservations instantanées non autorisées</div>
          )}
        </div>
      </div>

      {/* MODAL */}
      <div className="modal fade" id={`fullScreen${propsData.vehiculeAnnonceId}`} tabIndex="-1">
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header">
              <button className="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div className="modal-body">
              {isLoading ? (
                <Skeleton count={5} />
              ) : (
                <DetailsAnnonceModal
                  annonceID={propsData.vehiculeAnnonceId}
                  vehiculeId={propsData.Vehicle.id}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AnnonceItem2;
